<template>
  <div class="d-flex align-items-center justify-content-between px-3 py-1">
    <div :style="{ 'font-size': `${size}px` }">
      <div class="fw-bold">
        <slot name="title"></slot>
      </div>
      <div class="text-subtitle">
        <slot name="subtitle"></slot>
      </div>
    </div>
    <div :class="['collapse-handle', { 'fw-bold -clear-dimensions': !toggle }]">
      <slot name="handle">
        <img v-b-toggle="`collapse-toggle-${collapseToggle}`" src="@/assets/images/chevron-down.png"
          alt="collapse-order-summary" v-if="toggle">
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    toggle: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: "18"
    }
  },
  computed: {
    collapseToggle() {
      return this.toggle.replace(/ /g, '-').toLowerCase();
    }
  }
}
</script>

<style lang="scss" scoped>
.fw-bold {
  font-size: 18px;
}

.text-subtitle {
  font-size: 14px;
  color: #87929D;
}

.collapse-handle {
  width: 24px;
  height: 24px;
  img {
    transition: all 0.2s ease-in;
  }
  .collapsed {
    transform: rotate(-90deg);
  }

  &.-clear-dimensions {
    width: inherit;
    height: inherit;
    font-size: 18px;
  }

  &>img {
    cursor: pointer;
    max-width: 100%;
    max-height: 100%;
  }
}
</style>
